import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class FeaturesService {
    constructor() { }

    isEnabled(featureName: keyof AppFeatures): boolean {
        return __FEATURES__[featureName]
    }
}
